import { Card, CardContent, Grid, Typography } from '@mui/material';
import ButtonBack from '../Breadcrumb/ButtonBack';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useReintegro } from './hooks/useReintegro';
import { Fragment, useEffect } from 'react';
import { EstadoSolicitudReintegro } from './components/EstadoSolicitudReintegro';
import { PreviewBox } from '../Common/PreviewBox';
import { PreviewField } from '../Common/PreviewField';
import { PreviewFieldContainer } from '../Common/PreviewFieldContainer';
import { PreviewFileField } from '../Common/PreviewFileField';

// (formatNumber removed — not used in this component)

const formatDate = (value = null) => {
  if (!value) {
    return;
  }
  const date = new Date(value);
  const result = new Intl.DateTimeFormat('es-AR').format(date);
  return result;
};

export const REINTEGRO_CODIGO_ESTADO_APROBADO = '4';

export const ShowReintegro = () => {
  const history = useHistory();
  const { reintegro: reintegroSelected } = history?.location?.state || {};
  const { getReintegro, reintegro, documentacionList } = useReintegro();

  useEffect(() => {
    if (reintegroSelected?.id) {
      getReintegro(reintegroSelected.id);
    }
  }, []);

  return (
    <div className='container'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ButtonBack marginBottom='1' variant='text' size='small' />
          <Card sx={{ width: '100%', p: 1, paddingX: { xs: 0, sm: 1 } }}>
            <CardContent>
              <Grid container spacing={1} rowSpacing={1} gap={1}>
                <Grid item>
                  <Typography variant='h5' component={'span'}>
                    Consulta de Solicitud de Reintegro
                  </Typography>
                </Grid>
                {reintegro?.estado?.codigoEstado && (
                  <Grid item xs={12}>
                    <EstadoSolicitudReintegro estadoSolicitud={reintegro.estado} />
                  </Grid>
                )}

                {reintegro && (
                  <>
                    {/* Solicitud de reintegro */}
                    <Grid item xs={12}>
                      <PreviewBox title='Solicitud de Reintegro' alignItems='center'>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='id'
                            label='Número'
                            value={reintegro.solicitudCobertura.idSolicitudCoberturaFormateado}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='tipoTramite'
                            label='Tipo de Trámite'
                            value={reintegro.tipoCobertura.descripcion}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='fechaDeSolicitud'
                            label='Fecha de Solicitud'
                            value={formatDate(reintegro.solicitudCobertura.fechaGenerada) || '-'}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='estadoActual'
                            label='Estado'
                            value={reintegro.estado.descripcionEstadoSolicitudCobertura}
                          />
                        </Grid>
                        {reintegro.estado.codigoEstado === REINTEGRO_CODIGO_ESTADO_APROBADO && (
                          <>
                            {/* <Grid item xs={12} sm={6}>
                          <PreviewFieldContainer>
                            <PreviewFileField
                              id='formatted-text-mask-input'
                              label={
                                'Providencia ' +
                                formatNumber(reintegro.estado.idHistorialEstadoSolicitudCobertura)
                              }
                              href={reintegro.providenciaUrl}
                            />
                          </PreviewFieldContainer>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <PreviewField
                            id='fechaInicio'
                            label='Inicio Vigencia'
                            value={formatDate(reintegro.solicitudCobertura.fechaIniciada) || '-'}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <PreviewField
                            id='fechaVencimiento'
                            label='Vencimiento'
                            value={formatDate(reintegro.solicitudCobertura.vencimiento) || '-'}
                          />
                        </Grid> */}
                          </>
                        )}
                      </PreviewBox>
                    </Grid>

                    {/* Archivos adjuntos */}
                    <Grid item xs={12}>
                      <PreviewBox title='Documentación Presentada'>
                        {documentacionList?.length > 0 &&
                          documentacionList.map((grupo) => {
                            if (grupo?.documentos?.length === 0) {
                              return null;
                            }

                            return (
                              <Fragment key={grupo.codigo}>
                                {grupo.documentos.map((doc, idx) => {
                                  return (
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      key={doc.idHistorialDocumentacionSolicitudCobertura}
                                    >
                                      <PreviewFieldContainer>
                                        <PreviewFileField
                                          label={`${doc.documentacion} - ${idx + 1}`}
                                          src={doc?.path || ''}
                                        />
                                      </PreviewFieldContainer>
                                    </Grid>
                                  );
                                })}
                              </Fragment>
                            );
                          })}
                      </PreviewBox>
                    </Grid>

                    {/* Datos del afiliado */}
                    <Grid item xs={12}>
                      <PreviewBox title='Afiliado'>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='dni'
                            label='Documento'
                            value={`${reintegro.afiliado.numeroDocumentoFormateado}`}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <PreviewField
                            id='nya'
                            label='Apellido y Nombre'
                            value={`${reintegro.afiliado.apellidoNombreFormateado}`}
                          />
                        </Grid>
                      </PreviewBox>
                    </Grid>

                    {/* Reintegro */}
                    <Grid item xs={12}>
                      <PreviewBox title={'Motivo del Reintegro'}>
                        <Grid item xs={12}>
                          <PreviewField
                            id='observaciones'
                            label={''}
                            value={
                              reintegro?.estado?.observacion
                                ? `${reintegro.estado.observacion[0].toUpperCase()}${reintegro.estado.observacion.slice(
                                    1,
                                  )}`
                                : '-'
                            }
                            multiline
                          />
                        </Grid>
                      </PreviewBox>
                    </Grid>
                  </>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};
